import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OfferpackComponent } from './offerpack.component';

const routes: Routes = [
    {
        path: ':packid',
        component: OfferpackComponent
    },
    {
        path: '',
        component: OfferpackComponent
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class OfferpackRoutingModule { }
